module.exports = __webpack_public_path__ + "static/media/purecss.597aac9f.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/purecss.ico
// module id = 172
// module chunks = 0